module.exports = __webpack_public_path__ + "img/logo-blue-en.60888d45.png";